import React from 'react';
import classNames from 'clsx';

import { FormRowValidationMessageProps } from './FormRowValidationMessage.interface';
import { useStyles } from './FormRowValidationMessage.styles';
import { Alert } from 'app/components/Alert';
import {
  ControlTypeEnum,
  MessagesEnum,
  MessageTypeEnum,
} from 'app/shared/enums';

export default function FormRowValidationMessage(
  props: FormRowValidationMessageProps
) {
  const classes = useStyles(props);
  const { message, questionType, className } = props;

  return message && message.visible ? (
    <Alert
      text={message.content}
      type={message.type}
      icon={false}
      className={classNames(
        {
          [classes.dangerAlert]: message.type === MessageTypeEnum.Danger,
          [classes.spaceTop]: message.type !== MessageTypeEnum.Danger,
          [classes.checkboxValidationMessage]:
            questionType === ControlTypeEnum.Checkbox,
          [classes.leasingVehicleTypeMessage]:
            message.key === MessagesEnum.NoInsuranceForThisVehicleType,
        },
        className
      )}
    />
  ) : null;
}
